const namespace = {
  filters: {
    navigation: {
      scrollLeftAriaLabel: "Défiler vers la gauche",
      scrollRightAriaLabel: "Défiler vers la droite",
      allFiltersAriaLabel: "Voir tous les filtres",
    },
    radius: {
      title: "Rayon :",
      value: "{{value}} {{unit}}",
    },
    popup: {
      title: "Filtres",
      description: "Veuillez sélectionner une option",
      cta: {
        reset: "Réinitialiser tout",
        apply: "Appliquer le filtre",
      },
    },
  },
} as const;

export default namespace;
